import { useEffect, useState } from "react"
import Head from "next/head"
import { useGlobalState } from "providers/globalState"

export default function SeoMetaFields({ page }) {
    const { site } = useGlobalState()
    const [canonicalURL, setCanonicalURL] = useState(null)

    useEffect(() => {
        const canonicalURL = window.location.href
        setCanonicalURL(canonicalURL)
    }, [])

    if (!page) {
        return null
    }

    const { title, seoMetaTitle, seoMetaDescription } = page

    // The title is either the manually set SEO title  or the page title plus the site name
    // The description is only included in the head if it is provided manually

    const pageTitle = title.replace(/<[^>]*>?/gm, "") || seoMetaTitle
    const seoTitle = seoMetaTitle ? seoMetaTitle : pageTitle + " | " + site.meeting.seoMetaTitle

    return (
        <Head>
            <title>{seoTitle}</title>
            {seoMetaDescription && <meta name="description" content={seoMetaDescription} />}
            {canonicalURL && <link rel="canonical" href={canonicalURL} />}
        </Head>
    )
}
